<span class="{{class}} svg-icon" #iconTag>
    <!-- {{icon}} -->
    <!-- <img class="svg-icon" src="{{icon}}"> -->
</span>